import { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { TimeWheelContent } from '../TimeWheel/TimeWheelContent.js';
import { CalendarWithTimeWheelFooter } from './CalendarWithTimeWheelFooter.js';
import { StyledCalendar, StyledCalendarWithTimeWheelWrapper } from './Styleds.js';

export const CalendarWithTimeWheelContent = (): JSX.Element => {
  const {
    getProps,
    props: { readOnly, applyAriaDisabled },
  } = useContext(ControlledDateTimePickerContext);
  return (
    <StyledCalendarWithTimeWheelWrapper
      data-testid={ControlledDateTimePickerDatatestid.CONTROLLER_COMPONENT.CALENDAR_TIMEWHEEL}
      getOwnerProps={getProps}
      $readOnlyStyles={readOnly || applyAriaDisabled}
    >
      <StyledCalendar />
      <TimeWheelContent />
      <CalendarWithTimeWheelFooter />
    </StyledCalendarWithTimeWheelWrapper>
  );
};
